<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>홍보물품대장</p>
                <div class="area_button">
                    <button type="button" class="blueBtn" @click="showModal(null)">
                        <span>물품 등록</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_tab">
                        <div
                            :class="{ selected: state.dept === 0 }"
                            @click="
                                state.dept = 0;
                                router.push({ name: 'item', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>공용</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 1 }"
                            @click="
                                state.dept = 1;
                                router.push({ name: 'item', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>상담팀</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 3 }"
                            @click="
                                state.dept = 3;
                                router.push({ name: 'item', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>현장팀</span>
                        </div>

                        <div
                            :class="{ selected: state.dept === 6 }"
                            @click="
                                state.dept = 6;
                                router.push({ name: 'item', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>감시팀</span>
                        </div>
                    </div>
                    <div class="area_search">
                        <div>
                            <label>작성일</label>
                            <div>
                                <div class="datepicker"><input type="date" id="startDate" v-model="state.startDate" @change="changeStartDate" /></div>
                                <span>~</span>
                                <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate" @change="changeEndDate" /></div>
                                <button
                                    type="button"
                                    @click="
                                        setDateToToday();
                                        fnGetList(1);
                                    "
                                >
                                    오늘날짜
                                </button>
                            </div>
                        </div>
                        <div>
                            <label>검색조건</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType1">
                                        <!-- <option value="">선택해주세요.</option> -->
                                        <option v-for="item in searchCondition" :value="item.key">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>

                                <input
                                    type="text"
                                    name="searchText"
                                    v-model="state.searchText1"
                                    placeholder="검색어를 입력해주세요."
                                    v-on:keyup.enter="fnGetList(1)"
                                />
                            </div>
                        </div>

                        <div class="area_button">
                            <button
                                type="button"
                                @click="
                                    reset();
                                    fnGetList(1);
                                "
                            >
                                초기화
                            </button>
                            <button type="button" @click="fnGetList(1)">검색</button>
                        </div>
                    </div>
                </div>

                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>

                            <div class="total_length">
                                {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageState.list"
                                :columns="pageState.fields"
                                :totalLength="pageState.length"
                                :perPage="pageState.perPage"
                                :cntPage="pageState.cntPage"
                                :current-page="pageState.currentPage"
                                :isLoading="pageState.isLoading"
                                @onRowClick="fnRowClick"
                                @onPaging="fnGetList"
                                @onNextPage="fnGoPage"
                                @onPrevPage="fnGoPage"
                                @onFirstPage="fnGoPage"
                                @onLastPage="fnGoPage"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <ItemAdd v-if="state.isShowAddModal" :data="state.data" @callback="callbackModal" @close="closeModal"></ItemAdd>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onActivated,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        ItemAdd,
        useRoute,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, ItemAdd },
        setup() {
            const global = globalStore();
            const user = userStore();
            const route = useRoute();

            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setDate(today.getDate() - 30);

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                searchType1: "title" as string,
                searchText1: "" as string,
                dept: 0 as number,
                order: 0 as number,

                isShowAddModal: false as boolean,
                data: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const searchCondition = [
                // { key: "type", name: "세부항목" },
                { key: "title", name: "물품명" },
                // { key: "writer", name: "작성자" },
                // { key: "team", name: "작성팀" },
            ];

            const stateList = [
                { key: 0, name: "데이터 없음" },
                { key: 1, name: "진행" },
                { key: 2, name: "종결" },
                { key: 3, name: "보류" },
                { key: 4, name: "비해당" },
            ];

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "", label: "No.", class: "text-center" },
                    { key: "name", label: "물품명", class: "text-center", clickable: true },
                    {
                        key: "file",
                        label: "썸네일",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            if (row.file) return `<span class='table_thumbnail'><img src = "${row.file}"/></span>`;

                            return `<span class='table_thumbnail'><img src = "img/no_img.png"/></span>`;
                        },
                    },
                    { key: "cnt", label: "수량", class: "text-center" },
                    { key: "team", label: "부서", class: "text-center" },
                    { key: "writer", label: "등록자", class: "text-center" },
                    {
                        key: "createDate",
                        label: "등록일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormat(row.createDate, ".", true);
                        },
                    },
                    {
                        key: "btnModal",
                        label: "수정",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            return "<img src = 'img/modify_icon.png' style = 'width:24px; height:auto;cursor:pointer'>";
                        },
                    },
                ],
            });

            onActivated(() => {
                initState();
                if (!route.query.dept) {
                    state.dept = 0;
                } else {
                    state.dept = Number(route.query.dept);
                }
                router.replace({ name: "item", query: { dept: state.dept } });

                // state.startDate = dayAgo.toLocaleDateString("sv-SE");
                // state.endDate = today.toLocaleDateString("sv-SE");
                fnGetList(pageState.currentPage);
            });

            watch(
                () => route.query.dept,
                () => {
                    if (route.name !== "item") return;
                    if (!route.query.dept) {
                        state.dept = 0;
                        pageState.currentPage = 1;
                        router.replace({ name: "item", query: { dept: state.dept } });
                    } else if (Number(route.query.dept) !== state.dept) {
                        state.dept = Number(route.query.dept);
                        pageState.currentPage = 1;
                    }
                    // state.startDate = dayAgo.toLocaleDateString("sv-SE");
                    // state.endDate = today.toLocaleDateString("sv-SE");
                    fnGetList(pageState.currentPage);
                },
            );

            const initState = () => {
                state.isShowModal = false;
                state.isShowAddModal = false;
                state.data = {};
                state.modalTab = -1;
                state.modalIsResult = false;
                state.modalTitle = "";
                state.modalContent = "";
                pageState.list = [];
                pageState.isLoading = false;
            };

            const reset = () => {
                state.startDate = "";
                state.endDate = "";
                state.searchType1 = "title";
                state.searchText1 = "";
                state.dept = 0;
                state.order = 0;
            };

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.item.ReqItemList = {
                    page: page,
                    size: pageState.perPage,
                    searchType: state.searchType1,
                    searchText: state.searchText1,
                    order: state.order,
                    dept: state.dept,
                    startDate: state.startDate,
                    endDate: state.endDate,
                };
                let res: types.ResPaging = await apiService.item.list(param);

                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "btnModal") showModal(row);
                else if (col.key === "name") router.push({ name: "itemHistory", params: { id: row.idx } });
                else if (col.key === "file") viewImage(row.file);
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            const setDateToToday = () => {
                state.startDate = today.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const showModal = (data: any) => {
                state.data = data;
                state.isShowAddModal = true;
            };

            const closeModal = () => {
                state.isShowAddModal = false;
            };

            const callbackModal = async (param: any) => {
                if (param.idx > 0) {
                    if (await checkRequiredValue(param)) {
                        const param_for_modify: types.item.ReqItemForModify = {
                            idx: param.idx,
                            name: param.name,
                            isShare: param.isShare ? 1 : 0,
                            file: param.file,
                            team: param.dept,
                        };
                        const res = await apiService.item.modify(param_for_modify);
                        if (res.returnCode === 0) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "저장이 완료되었습니다.";
                            state.isShowModal = true;
                            state.isShowAddModal = false;
                            fnGetList(pageState.currentPage);
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                } else {
                    if (await checkRequiredValue(param)) {
                        const param_for_add: types.item.ReqItem = {
                            name: param.name,
                            isShare: param.isShare ? 1 : 0,
                            file: param.file,
                            team: param.dept,
                        };
                        const res = await apiService.item.add(param_for_add);
                        if (res.returnCode === 0) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "저장이 완료되었습니다.";
                            state.isShowModal = true;
                            state.isShowAddModal = false;
                            fnGetList(pageState.currentPage);
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                }
            };

            const checkRequiredValue = async (param: any) => {
                if (!param.name) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "물품명을 입력해주세요.";
                    state.isShowModal = true;
                    return false;
                } else if (!param.dept) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "부서를 선택해주세요.";
                    state.isShowModal = true;
                    return false;
                }
                return true;
            };

            const viewImage = async (param: string) => {
                state.modalTab = 4;
                state.modalTitle = "알림";
                state.modalContent = param;
                state.isShowModal = true;
            };

            const changeStartDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                }
            };
            const changeEndDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성일 범위가 잘못 선택되었습니다.";
                    state.isShowModal = true;
                }
            };

            return {
                state,
                pageState,
                reset,
                fnRowClick,
                fnGoPage,
                fnGetList,
                CommonUtils,
                setDateToToday,
                searchCondition,
                stateList,
                CommonOptions,
                showModal,
                closeModal,
                callbackModal,
                router,
                changeStartDate,
                changeEndDate,
            };
        },
    };
</script>
<style>
    .sch_list label:last-child {
        border-right: white;
    }
</style>
